(function() {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('Quoting', Quoting);

    Quoting.$inject = ['$resource'];

    function Quoting ($resource) {
        var resourceUrl =  'api/quotings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
